module.exports = __webpack_public_path__ + "static/img/brees-2013-slide-1.03f1f7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2013-slide-1.jpg
// module id = 6GaJ
// module chunks = 1